import { HighlightedMessage, ReactCarouselSlider, TranslationMessage } from 'components';
import Button from 'components/buttons/Button';
import { threeitemslider } from 'utils/constants';
import { Image } from 'components/Image';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { UrlFirstSegment, validURL } from 'utils/global';
import defaultimage from 'assets/images/defaultsquare.png';
import popularsvg from 'assets/images/svg/popularpattern.svg';
interface Props {
	content: {
		[key: string]: any;
	};
	productList?: any;
	type: string;
}
export const generateLink = (item, buttonLink, buttonText) => {
	if (validURL(buttonLink))
		return (
			<a href={buttonLink} target="_blank">
				<TranslationMessage data={item} value={buttonText} />
			</a>
		);
	else
		return item[buttonText] && (
			<Link to={buttonLink ? buttonLink : '#'}>
				<TranslationMessage data={item} value={buttonText} isHtmlParse />
			</Link>
		);
};

const ProductLayoutOne = ({ content, productList, type }: Props) => {
	let productData = productList;
	const urlFirstSegment = UrlFirstSegment();

	let conditionalProps = { infinite: false };
	if (productData?.length > 2) {
		conditionalProps = { infinite: true };
	}

	if (productData?.length > 0) {
		return (
			<section className="py-5 promosection-one homepagesolution blacktheme">
				<div className="container">
					<div className="row align-items-center">
						<div className="col-md-4">
							<h2 className="font-weight-bold text-danger mb-3">
								<HighlightedMessage data={content} value="text" className="text-success" />
							</h2>
							<h4 className=" text-d-gray mb-3">
								<TranslationMessage data={content} value="subtext" />
							</h4>

							<div className="d-flex flex-column flex-sm-row">
								<Button buttonStyle="btn-gradient--solid" buttonSize="btn--medium" icon type="button" url={content.button_url}>
									<TranslationMessage data={content} value="button_text" />
								</Button>
								<div className="mr-3 mb-2"></div>

								<Button buttonStyle="btn-success--outline" buttonSize="btn--medium" icon type="button" url={content.second_button_url}>
									<TranslationMessage data={content} value="second_button_text" />
								</Button>
							</div>
						</div>

						<div className="col-md-8  promoslider blackthemeslider">
							<ReactCarouselSlider {...threeitemslider} {...conditionalProps}>
								{productData.map((product, index) => (
									// <div key={index} className={`grid-with-four-item rounded overflow-hidden ${renderClass(product)}`} id={index}>
									<div key={index} className={`grid-with-four-item rounded overflow-hidden `}>
										<div className="grid-with-four-item rounded overflow-hidden">
											{/* <TranslationImage className="img-fluid" data={product} value="thumb_image" /> */}
											<Image className="img-fluid" src={product.thumb_image} onErrorSrc={defaultimage} />
											<span>
												<TranslationMessage data={product} value="title" />
											</span>
											{/* offer tag */}
											{product.product_popularity == "normal" || "" ? "" : <div className="blinkoffertag" style={{ backgroundImage: `url(${popularsvg})` }}>
												<HighlightedMessage data={product} value="product_popularity" />
											</div>}

											<div className="grid-with-four-item-overlay"></div>
											<div className="grid-with-four-item-details">
												<h5 className="text-success font-weight-bold">
													<TranslationMessage data={product} value="title" />
												</h5>
												<h6 className="text-white mb-4">
													<TranslationMessage data={product} value="short_description" isHtmlParse />
												</h6>
												<div className="grid-card-link-group">
													<Link to={`${urlFirstSegment}/${type}/${product.category_slug}/${product.slug}`}>
														<FormattedMessage id="product.learn-more" />
													</Link>
													{generateLink(product, product.page_header_settings_first_button_link, 'page_header_settings_first_button_text')}
												</div>
											</div>
										</div>
									</div>
								))}
							</ReactCarouselSlider>
						</div>
					</div>
				</div>
			</section>
		);
	} else {
		return null;
	}
};

export { ProductLayoutOne };
